import { createGenericContext, GetBemBlocksWith } from "@ebsco-ui/utils";
import * as React from "react";

export interface ModalContext {
  getBlocksWith: GetBemBlocksWith;
  onClose: (event: React.MouseEvent | React.KeyboardEvent) => void;
}

export const {
  useGenericContext: useModalContext,
  GenericContextConsumer: ModalContextConsumer,
  GenericContextProvider: ModalContextProvider,
} = createGenericContext<ModalContext>({
  errorMessage:
    "Modal compound components cannot be rendered outside the Modal component",
});
